'use strict';

const formatTextForBloodhound = text =>
  `${text.toLowerCase().split(' ').join('-')}`;

const getTraitBhwTag = traitText =>
  `VariationsTrait:${formatTextForBloodhound(traitText)}`;

const getOptionBhcTag = optionText =>
  `option:${formatTextForBloodhound(optionText)}`;

module.exports = { getOptionBhcTag, getTraitBhwTag };
